import { setOptions } from '../actions/advertisingOptionsActions';
function resetFunction() {
    setOptions({
        consentString: null,
        allowAccess: null,
        allowAdSelection: null,
        allowContentSelection: null,
        allowPersonalization: null,
        allowMeasurement: null,
    });
}
export default resetFunction;
//# sourceMappingURL=reset.js.map